import { render } from "./Pop.vue?vue&type=template&id=b3c5d774"
import script from "./Pop.vue?vue&type=script&lang=js"
export * from "./Pop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__